// src/components/Profile/ProfileSection.jsx
import React from 'react';

export default function ProfileSection({ user, profileImage, onEditProfile }) {
  return (
    <div className="profile-card card-animate">
      <div className="profile-header">
        <h3>My Profile</h3>
        <span className="last-login">
          Last login: {new Date(user?.last_login || Date.now()).toLocaleDateString()}
        </span>
      </div>

      <div className="profile-image-container">
        <div className="profile-image">
          {profileImage ? (
            <img src={profileImage} alt="Profile" />
          ) : (
            (user?.name || 'U').charAt(0).toUpperCase()
          )}
        </div>
      </div>

      <div className="profile-details">
        <div className="detail-row">
          <span className="detail-label">{user?.name}</span>
        </div>
        <div className="detail-row">
          <span className="detail-value">{user?.email}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Phone:</span>
          <span className="detail-value">{user?.phone || 'Not provided'}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Date of Birth:</span>
          <span className="detail-value">{user?.dob || 'Not provided'}</span>
        </div>
      </div>

      <button className="edit-btn" onClick={onEditProfile}>
        <i className="ph ph-pencil-simple"></i> Edit Profile
      </button>
    </div>
  );
}